<!--
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-06-26 14:22:15
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2025-12-26 11:11:22
 * @FilePath: \nb-h5-game-webd:\new_project\betdoce-web\src\components\RuleDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <v-dialog v-model="visibleProxy" @click:outside="close" class="rule-dialog-mask">
    <v-card class="rule-dialog-box">
      <div class="rule-dialog-header">
        <img src="@/assets/images/h5/vip-right.png" alt="Fechar" class="rule-dialog-close" @click="close" />
        <span class="rule-dialog-title">{{ title }}</span>
      </div>
      <div class="rule-dialog-content">
        <slot>
          <v-textarea :model-value="content" readonly variant="outlined" hide-details auto-grow class="rule-textarea"
            :class="{ 'rule-textarea-readonly': true }"></v-textarea>
        </slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: "Ajuda",
  },
  content: {
    type: String,
    default: "",
  },
});
const emit = defineEmits(["update:visible"]);

// v-model 兼容
const visibleProxy = computed({
  get: () => props.visible,
  set: (v) => emit("update:visible", v),
});

function close() {
  emit("update:visible", false);
}
</script>

<style lang="scss" scoped>
:deep(.v-card) {
  border-radius: 8px !important;
  background: #1e2332 !important;
}

:deep(.v-overlay__content) {
  min-width: 320px;
  max-width: 580px;
}

.rule-dialog-mask {
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rule-dialog-box {
  background: #1e2332;
  border-radius: 8px;
  min-width: 320px;
  max-width: 580px;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  position: relative;
}

.rule-dialog-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}

.rule-dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.rule-dialog-close {
  position: absolute;
  left: 0;
  // width: 22px;
  height: 14px;
  transform: rotate(180deg);
  cursor: pointer;
  user-select: none;
}

.rule-dialog-content {
  background: #0f141b;
  border-radius: 8px;
  padding: 12px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
  max-height: 480px;
  overflow-y: auto;
  word-break: break-word;
}

.rule-textarea {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
  height: 422px;
}

.rule-textarea-readonly {
  background: transparent !important;
}

.rule-textarea-readonly :deep(.v-field) {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.rule-textarea-readonly :deep(.v-field__input) {
  min-height: auto !important;
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  padding: 0 !important;
  mask-image: none;
}

.rule-textarea-readonly :deep(.v-field__outline) {
  display: none !important;
}
</style>
